import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/$orgId/jobs/post/")({
  beforeLoad: () => {
    throw redirect({ to: "/org/providers" });
  },
});
